import { useMatch } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ROUTES, getRouteTitle } from '../../../../../constants/RouteNameMapping';
import { NavigationWrapper } from '../NavigationWrapper';
import { SubSectionNavigation } from '../../SubSectionNavigation/SubSectionNavigation';
import SubSectionNavItems from '../../SubSectionNavigation/SubSectionNavItems';
import { MaggieFeatureFlags } from '../../../../../util/feature-flags';

export function FinanceNavigation() {
  const match = useMatch(`/${ROUTES.FINANCE2}/*`);
  const { showAllSecurities } = useFlags<MaggieFeatureFlags>();
  if (match === null) {
    return null;
  }

  const FinanceSections = [
    {
      id: ROUTES.FINANCE2_OVERVIEW,
      value: 'All Transactions',
    },
  ];
  if (showAllSecurities) {
    FinanceSections.push({
      id: ROUTES.FINANCE_ALL_SECURITIES,
      value: getRouteTitle(ROUTES.FINANCE_ALL_SECURITIES),
    });
  }
  FinanceSections.push({
    id: ROUTES.FINANCE_RECON,
    value: getRouteTitle(ROUTES.FINANCE_RECON),
  });

  return (
    <NavigationWrapper title='Finance'>
      <SubSectionNavigation title='Overview'>
        <SubSectionNavItems sectionList={FinanceSections} parentRoute={ROUTES.FINANCE2} />
      </SubSectionNavigation>
    </NavigationWrapper>
  );
}
